import { HiStar } from "react-icons/hi";

const FrequencyCountChip = ({
  count,
  onClick,
}: {
  count: number;
  onClick?: () => void;
}) => {
  const isCouponPoint = count >= 10 && count % 10 === 0;

  return (
    <div
      className={`flex items-center justify-center h-12 w-20 gap-0.5 border rounded-3xl ${
        isCouponPoint ? "border-blue-500 bg-blue-50" : "border-gray-300"
      } `}
      onClick={onClick}
    >
      <div className="bg-yellow-100 rounded-full p-0.5">
        <HiStar className="text-yellow-500" />
      </div>
      <div className="flex items-baseline justify-center gap-0.5 mb-0.5">
        <span className="text-3xl font-bold text-primary">{count % 10}</span>
        <span className="text-lg text-primary/80">/</span>
        <span className="text-lg text-primary/80">10</span>
      </div>
    </div>
  );
};

export default FrequencyCountChip;
